//Generated File
export default class NaMaErrors{
	static readonly AUTHENTICATION_ERROR = `AUTHENTICATION_ERROR`;
	static readonly AUTHORIZATION_ERROR = `AUTHORIZATION_ERROR`;
	static readonly DATABASE_SEEK = `DATABASE_SEEK`;
	static readonly DUPLICATE_FILE_PATH = `DUPLICATE_FILE_PATH`;
	static readonly FIELD_MUST_BE_EMPTY = `FIELD_MUST_BE_EMPTY`;
	static readonly HO_ONLINE = `HO_ONLINE`;
	static readonly INSUFFICIENT_QUANTITY = `INSUFFICIENT_QUANTITY`;
	static readonly LOGIN_OTP_REQUIRED = `LOGIN_OTP_REQUIRED`;
	static readonly NONE = `NONE`;
	static readonly RECORD_NOT_FOUND = `RECORD_NOT_FOUND`;
	static readonly RECORD_NOT_VALID = `RECORD_NOT_VALID`;
	static readonly REPEATED_CODE = `REPEATED_CODE`;
	static readonly REQUIRED_NOT_PROVIDED = `REQUIRED_NOT_PROVIDED`;
	static readonly STOCK_TAKING_IN_PROGRESS = `STOCK_TAKING_IN_PROGRESS`;
	static readonly WEIGHTED_BEFORE = `WEIGHTED_BEFORE`;
}
